import template from './flight-recommendation.html';

const DIRECTIVE_NAME = FlightRecommendation.DIRECTIVE_NAME = 'ktFlightRecommendation';
export default function FlightRecommendation() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: FlightRecommendationController,
        controllerAs: '$ctrl',
        scope: {
            recommendation: `=${DIRECTIVE_NAME}`,
            searchParameters: `=${DIRECTIVE_NAME}SearchParameters`,
            selectedFlights: `=${DIRECTIVE_NAME}SelectedFlights`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function FlightRecommendationController(
    flightSegmentService,
    flightSegmentAlternativesService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        preSelectAlternatives,
    });

    function $onInit() {
        preSelectAlternatives(vm.selectedFlights, vm.recommendation);
    }

    function preSelectAlternatives(selectedFlights, recommendation) {
        // TODO move to some service
        const [firstSegment, ...segments] = recommendation.FlightSegments;
        const [firstGroup] = firstSegment.FlightGroups;
        flightSegmentService.selectGroup(selectedFlights, firstSegment, firstGroup);

        segments.forEach((segment) => {
            const groups = segment.FlightGroups;
            const groupThatDoesNotOverlapPreviousSegment = groups.find((group) =>
                !flightSegmentAlternativesService.doesOverlapPreviousSegment(
                    recommendation,
                    segment,
                    group,
                    selectedFlights
                ));

            flightSegmentService.selectGroup(selectedFlights, segment, groupThatDoesNotOverlapPreviousSegment);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/flight-recommendation/flight-recommendation-component.js